import { notification } from 'antd';
import { useState } from 'react';

import { autoCreditApi } from '@/integrations/app.api/auto-credit.api';
import { handleError } from '@/services/handleError';
import { useAppDispatch, useAppSelector } from '@/store';
import { getAttachedFilesByReqId } from '@/store/financingStep.slice';
import { getResponsesByRequestId } from '@/store/offerStep.slice';

import useAutoCredRequestId from '../../hooks/useAutoCredRequestId';

// Процесс для онлайн евраза
const useConfirmBitrix = () => {
  const dispatch = useAppDispatch();

  const { selectedBank } = useAppSelector((state) => state.financingStep);

  const { requestId } = useAutoCredRequestId();

  const [confirmBitrixLoading, setConfirmBitrixLoading] = useState(false);

  // Вызывается при статусе "waiting_for_docs_confirmation" для банков
  const handleConfirmBitrix = async () => {
    if (!selectedBank?.id) return;

    setConfirmBitrixLoading(true);
    try {
      await autoCreditApi.confirmBitrixDocuments(selectedBank.id);
      await dispatch(getResponsesByRequestId({ reqId: requestId }));
      await dispatch(getAttachedFilesByReqId(requestId));
      notification.success({
        title: 'Файлы успешно отправлены',
        duration: 5
      });
    } catch (error) {
      handleError(error);
    }
    setConfirmBitrixLoading(false);
  };

  return { handleConfirmBitrix, confirmBitrixLoading };
};

export default useConfirmBitrix;
